import React, { useRef } from 'react';
import styled from 'styled-components';
import Schallberechnung from './Schallberechnung';
import SoundArrowHorizontal from '../../assets/img/sound_arrow_horizontal.svg';
import SoundArrowDiagonal from '../../assets/img/sound_arrow_diagonal.svg';
import Checked from '../../assets/img/checked2.svg';
import Cross from '../../assets/img/cross.svg';
import Logo from '../../assets/img/geberit-logo.svg';
import Save from '../../assets/img/save.png';
import Load from '../../assets/img/loading.gif';
import mediaQ from '../theme/responsive';
import { borders } from '../theme/Borders';
import { colors } from '../theme/ColorTheme';
import { ButtonDisabled, ButtonPrimary } from '../theme/Buttons';
import DATA from '../data/data.js';
import { FormattedHTMLMessage } from 'react-intl';
import GridRow from './GridRow';
import Geraeusche from '../components/Infotemplates/Geraeusche';
import Normeninfo from '../components/Infotemplates/Normeninfo';
import SimpleBubble from '../components/SimpleBubble';
import MehrfamilienhausDIN from '../components/Infotemplates/MehrfamilienhausDIN';
import MehrfamilienhausVDI from '../components/Infotemplates/MehrfamilienhausVDI';
import Einfamilienhaus from '../components/Infotemplates/Einfamilienhaus';
import Imeigenenbereich from '../components/Infotemplates/Imeigenenbereich';
import KorrekturSchallpegel from '../components/Infotemplates/KorrekturSchallpegel';
import InfoBox from './InfoBox';
import { connect } from 'react-redux';
import jsPDF from 'jspdf';
import PrintVariables from './PrintVariables';

const styles = {
    fontFamily: 'sans-serif',
    textAlign: 'center',
};
const colstyle = {
    width: '30%',
};
const tableStyle = {
    width: '100%',
};
var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
var datum = new Date();
var heute = ' ' + datum.getUTCDate() + '/' + months[datum.getUTCMonth()] + '/' + datum.getUTCFullYear();

class Ergebnisse extends React.Component {
    state = {
        viewPortSmall: false,
    };
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleChange2 = this.handleChange2.bind(this);
        this.handleChange3 = this.handleChange3.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.changeIcon = this.changeIcon.bind(this);
    }
    changeIcon(event) {

    }

    handleChange(event) {
        this.setState({ titlePrint: event.target.value.toUpperCase() });
    }
    handleChange2(event) {
        this.setState({ erstelltPrint: event.target.value.toUpperCase() });
    }
    handleChange3(event) {
        this.setState({ beschreibungPrint: event.target.value.toUpperCase() });
    }

    handleSubmit(event) {



        this.setState({ titlePrintChanged: this.seperateText(this.state.titlePrint, 12) });

        if (this.state.beschreibungPrint != undefined) {
            this.setState({ beschreibungPrintChanged: this.seperateText(this.state.beschreibungPrint, 44) });
        }
      
        event.preventDefault();
        var inhaltButton = document.getElementById("downloadButton").innerHTML;
        document.getElementById("downloadButton").innerHTML = "das achte gebot";

        setTimeout(this.print2, 100);
        document.getElementById("downloadButton").innerHTML = inhaltButton;
        document.getElementById("iconButton").src = Load;
        document.getElementById("iconButton").style.width = "30px";
        

    }

    componentDidMount() {
       


        window.addEventListener('resize', this.viewPortSmall);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.viewPortSmall);
    }
    splitting = testing => {
        const testreturn = testing.split('*');
        return testreturn;
    };

    seperateText = (Textblock, CutValue) => {
        var zwischenspeicher = [Textblock, ''];
        var sidearray = ['', '', '', '', '', '', '', '', '', '', '', '', '', ''];
        var sidearray2 = ['', '', '', '', '', '', '', '', '', '', '', '', '', ''];
        var sidearray3 = ['', '', '', '', '', '', '', '', '', '', '', '', '', ''];
        var zaehler = 0;
        var zusatzzaehler = 0;

        //console.log("zwischenspeicher1");
        //console.log(zwischenspeicher);
        if (Textblock.length <= CutValue) {
            sidearray[0] = Textblock.toUpperCase();
        }
        //console.log("sidearray1");
        //console.log(sidearray);
        if (Textblock.length > CutValue) {
            zwischenspeicher = zwischenspeicher[0].split(' ');
        }
        //console.log("zwischenspeicher2");
        //console.log(zwischenspeicher);
        for (let index = 0; index < zwischenspeicher.length; index++) {
            zwischenspeicher[index] = zwischenspeicher[index].replace(/\n|\r/g, '');
        }
        for (let index = 0; index < zwischenspeicher.length; index++) {
            sidearray2[index + zusatzzaehler] = zwischenspeicher[index];
            if (zwischenspeicher[index].length > CutValue) {
                sidearray2[index + zusatzzaehler] = zwischenspeicher[index].slice(0, CutValue);
                zusatzzaehler = zusatzzaehler + 1;
                sidearray2[index + zusatzzaehler] = zwischenspeicher[index].slice(CutValue, zwischenspeicher[index].length);
            }
        }
        //console.log("sidearray2");
        //console.log(sidearray2);
        for (let index = 0; index < sidearray2.length; index++) {
            if (sidearray3[zaehler].length < CutValue && sidearray3[zaehler].length + sidearray2[index].length < CutValue) {
                sidearray3[zaehler] = sidearray3[zaehler] + ' ' + sidearray2[index];
            } else {
                if (index != 0) {
                    zaehler += 1;
                }
                sidearray3[zaehler] = sidearray2[index];

            }
        }
        //console.log("sidearray3 1");
        //console.log(sidearray3);
        for (let index = 0; index < sidearray3.length; index++) {
            sidearray3[index] = sidearray3[index].trim();
        }
        //console.log("sidearray3");
        //console.log(sidearray3);
        /*
        var Zaehler=0;
        var Zaehler2=0;
        var Zaehler3=0;
        var sidearray=["","","","","","","","","","","","","",""];
        sidearray=["","","","","","","","","","","","","",""];
        Zaehler=0;
     
     if(Textblock.length<CutValue){
        sidearray[0]=Textblock.toUpperCase();
    }
  //  console.log("start "+Textblock);
        if(Textblock.length>CutValue){
         
       //     console.log("start2 "+zwischenspeicher);
            if(zwischenspeicher[0].indexOf(" ")>0){
                zwischenspeicher=zwischenspeicher[0].split(" ");

            }

      //      console.log("schleife1 "+zwischenspeicher);

          while(Zaehler<zwischenspeicher.length){
                if(zwischenspeicher[Zaehler].length>CutValue-1){
  					var newstring=zwischenspeicher[Zaehler].slice(CutValue-1,zwischenspeicher[Zaehler].length);
                    zwischenspeicher[Zaehler]=zwischenspeicher[Zaehler].replace(newstring, "");
                    zwischenspeicher.splice(Zaehler, 0, newstring);
                }
                Zaehler+=1;
         //       console.log("schleife2 "+zwischenspeicher);
                

            }
            Zaehler2=0;
            Zaehler3=0;

            while(Zaehler2<zwischenspeicher.length){
                if(sidearray[Zaehler3].length+zwischenspeicher[Zaehler2].length<CutValue){
                    sidearray[Zaehler3]+=zwischenspeicher[Zaehler2].toUpperCase()+" ";
                    Zaehler2+=1;
                }else{
                    Zaehler3+=1; 
                }
         //       console.log(sidearray);
            //   alert(sidearray[Zaehler3]+ " zaehler2:"+Zaehler2+" zaehler3:"+Zaehler3);
                
            }
       
            */
        return sidearray3;
    };

    // }

    print2 = () => {
        //casting Formular

        // document.getElementById("iconButton").src=Load;
        // document.getElementById("iconButton").style.width="30px";

        //Abstaende allgemein
        var UnterBild = 170;

        //Schriftgroessen und Linienhoehe
        var TextsizeSmall = 8;
        var TextsizeH1 = 55;
        var TextsizeH2 = 15.8;
        var TextsizeMedium = 10;
        var TextsizeBig = 12;
        var ZeilenabstandGross = 21.2;
        var SeitenZahlen = 12;

        var ZeilenabstandKlein = 4;
        //Rahmen Blatt
        var RandSeite = 20;
        var RandOben = 10;
        //Titleseite
        var AbstandTitle = 10;
        var GrosserTextStartY = 126;
        var ZeilenabstandMittelTitle = 8;
        //adressSeite
        var ObersteZeile = 23.8;
        var ZeilenabstandMittel = 4.9;
        //Tabelle
        var spaltenBreiteRechts = 13;
        var tabelleOben = 30;
        var tabelleHeadlineUnten = tabelleOben + 6;
        var tabelleZeile1 = tabelleHeadlineUnten + 17;
        var tabelleZeile2 = tabelleZeile1 + 13;
        var tabelleUnten = tabelleZeile2 + 13;
        var Spalte1 = RandSeite + 26;
        var Spalte2 = Spalte1 + spaltenBreiteRechts;
        var Spalte3 = Spalte2 + spaltenBreiteRechts;
        var Spalte4 = Spalte3 + spaltenBreiteRechts;
        var Trenner1 = Spalte4 + 1;
        var Spalte5 = Trenner1 + spaltenBreiteRechts;
        var Spalte6 = Spalte5 + spaltenBreiteRechts;
        var Spalte7 = Spalte6 + spaltenBreiteRechts;
        var Spalte8 = Spalte7 + spaltenBreiteRechts;
        var Spalte9 = Spalte8 + spaltenBreiteRechts;
        var Spalte10 = Spalte9 + spaltenBreiteRechts;
        var Spalte11 = Spalte10 + spaltenBreiteRechts;

        //Seite3

        var counterBeschreibung = 0;
        var counter = 0;
        var DruckSilentPro = ['', ''];
        var MitBetaetigung1 = ['', ''];
        var OhneBetaetigung1 = ['', ''];
        var KeineAnforderung1 = ['', ''];
        var PrintHeadingSeperated = ['', ''];
        var footNote1 = ['', ''];
        var footNote2 = ['', ''];
        var Diagonal1 = ['', ''];
        var Fremden1 = ['', ''];
        var Angrenzend1 = ['', ''];
        var Ergebnis1 = ['', ''];
        var DIN41094 = ['DIN 4109-4:', '2018-01'];
        var DIN41091 = ['DIN 4109-1:', '2018-01'];
        var DIN4109 = ['DIN 4109', 'Beiblatt2:', '1989-11'];
        var ZwischenNote1 = document.getElementsByClassName('FussNote1')[0].innerHTML;
        counter = 0;
        footNote1 = ZwischenNote1.replace('<span>', '');
        footNote1 = footNote1.replace('</span>', '');
        footNote1 = footNote1.split('<br>');
        var ZwischenNote2 = document.getElementsByClassName('FussNote2')[0].innerHTML;
        footNote2 = ZwischenNote2.replace('<span>', '');
        footNote2 = footNote2.replace('</span>', '');
        footNote2 = footNote2.split('<br>');
        var DiagonalDarunter = document.getElementsByClassName('printDiagonalDarunter')[0].innerHTML;
        Diagonal1 = DiagonalDarunter.replace('<span>', '');
        Diagonal1 = Diagonal1.replace('</span>', '');
        Diagonal1 = Diagonal1.split('<br>');
        var FremdenBereich = document.getElementsByClassName('printFremdenBereich')[0].innerHTML;
        Fremden1 = FremdenBereich.replace('<span>', '');
        Fremden1 = Fremden1.replace('</span>', '');
        Fremden1 = Fremden1.split('<br>');
        var RaumAngrenzend = document.getElementsByClassName('printAngrenzenderRaum')[0].innerHTML;
        Angrenzend1 = RaumAngrenzend.replace('<span>', '');
        Angrenzend1 = Angrenzend1.replace('</span>', '');
        Angrenzend1 = Angrenzend1.split('<br>');
        var UeberschriftErgebnis = document.getElementsByClassName('printErgebnis')[0].innerHTML;
        Ergebnis1 = UeberschriftErgebnis.replace('<span>', '');
        Ergebnis1 = Ergebnis1.replace('</span>', '');
        Ergebnis1 = Ergebnis1.split(' ');

        var AnforderungKeine = document.getElementsByClassName('printKeineAnforderung')[0].innerHTML;
        KeineAnforderung1 = AnforderungKeine.replace('<span>', '');
        KeineAnforderung1 = KeineAnforderung1.replace('</span>', '');
        KeineAnforderung1 = KeineAnforderung1.split('<br>');
        var BetaetigungOhne = document.getElementsByClassName('printOhneBetaetigung')[0].innerHTML;
        OhneBetaetigung1 = BetaetigungOhne.replace('<span>', '');
        OhneBetaetigung1 = OhneBetaetigung1.replace('</span>', '');
        OhneBetaetigung1 = OhneBetaetigung1.split('<br>');
        var BetaetigungMit = document.getElementsByClassName('printMitBetaetigung')[0].innerHTML;
        MitBetaetigung1 = BetaetigungMit.replace('<span>', '');
        MitBetaetigung1 = MitBetaetigung1.replace('</span>', '');
        MitBetaetigung1 = MitBetaetigung1.split('<br>');

        var silentPro = document.getElementsByClassName('printFussnoteSilentPro')[0].innerHTML;
        silentPro = silentPro.replace('<span>', '');
        silentPro = silentPro.replace('</span>', '');
        DruckSilentPro = silentPro.split('<br>');

        var mit3Punkten = 0;

        var ueberschriftGrafik = document.getElementsByClassName('UeberschtriftPrintingView')[0].innerText;
        ueberschriftGrafik = ueberschriftGrafik.replace('Schalltechnischer Eignungsnachweis', '');
        PrintHeadingSeperated = ueberschriftGrafik.split('*');

        const pdf = new jsPDF('p', 'mm', 'a4');
        //-------------------------- Seite 1 -------------------------------------------
        //pdf.setFont('AktivGroteskGeberit_W_Rg');
        pdf.setFont(undefined, 'normal');
        pdf.addImage(document.getElementsByClassName('GeberitPrintLogo')[0], 164.4, 8.4, 26, 3.5);
        pdf.setFontSize(TextsizeH2);
        pdf.text(document.getElementsByClassName('PrintDatum')[0].innerText, RandSeite, 105);
        pdf.setFontSize(TextsizeH1);
        pdf.setTextColor(58, 117, 196);
        //pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.setFont(undefined, 'bold');
        if (this.state.titlePrintChanged != undefined) {
            while (this.state.titlePrintChanged[counter].length > 0) {
                pdf.text(this.state.titlePrintChanged[counter], RandSeite, GrosserTextStartY + ZeilenabstandGross * counter);
                counter += 1;
            }
        } else {
            pdf.text(this.state.titlePrint, RandSeite, GrosserTextStartY + ZeilenabstandGross * 0);
            counter += 1;
        }

        //pdf.setFont('AktivGroteskGeberit_W_Rg');
        pdf.setTextColor(0, 0, 0);
        pdf.setFontSize(TextsizeH2);
        if (this.state.erstelltPrint != undefined) {
            pdf.text(this.state.erstelltPrint, RandSeite, GrosserTextStartY + ZeilenabstandGross * (counter - 1) + AbstandTitle + ZeilenabstandMittelTitle * 0);
        }
        counterBeschreibung = 0;
        if (this.state.beschreibungPrintChanged != undefined) {
            while (this.state.beschreibungPrintChanged[counterBeschreibung].length > 0) {
                pdf.text(
                    this.state.beschreibungPrintChanged[counterBeschreibung],
                    RandSeite,
                    GrosserTextStartY +
                    ZeilenabstandGross * (counter - 1) +
                    AbstandTitle +
                    ZeilenabstandMittelTitle +
                    ZeilenabstandMittelTitle * counterBeschreibung
                );
                counterBeschreibung += 1;
            }
        } else {
            if (this.state.beschreibungPrint != undefined) {
                pdf.text(
                    this.state.beschreibungPrint,
                    RandSeite,
                    GrosserTextStartY +
                    ZeilenabstandGross * (counter - 1) +
                    AbstandTitle +
                    ZeilenabstandMittelTitle +
                    ZeilenabstandMittelTitle * counterBeschreibung
                );
            }
        }

        pdf.addImage(document.getElementsByClassName('PrintLogo2')[0], RandSeite, 238, 35.5, 35.5);

        //-------------------------- Seite 2 -------------------------------------------
        pdf.addPage();
        var base64Image = document.getElementsByClassName('PrintWallImage')[0];

        pdf.addImage(document.getElementsByClassName('GeberitPrintLogo')[0], 164.4, 8.4, 26, 3.5);
        //Wandgrafik
        pdf.addImage(base64Image, RandSeite, 20, 140, 140);
        pdf.setFontSize(TextsizeBig);
        //pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.setFont(undefined, 'bold');

        if (PrintHeadingSeperated[0].length < 30) {
            pdf.text(PrintHeadingSeperated[0], RandSeite, 24);
        } else {
            var newDoubleline = PrintHeadingSeperated[0].split('(');

            pdf.text(newDoubleline[0] , RandSeite, 24);
            if (newDoubleline[1] != undefined) {
                pdf.text('(' + newDoubleline[1], RandSeite, 28);
            }
        }
        //pdf.setFont('AktivGroteskGeberit_W_Rg');
        pdf.setFont(undefined, 'normal');
        if (PrintHeadingSeperated[1] != undefined) {
            pdf.text(PrintHeadingSeperated[1], RandSeite, 30);
        }
        pdf.setFontSize(SeitenZahlen);
        //pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.setFont(undefined, 'bold');
        pdf.setFontSize(TextsizeSmall);
        //--------------Auflistung Wandbeschreibung----------------------------------
        if (this.props.korrekturWerte.flaechengewicht) {
            mit3Punkten = 0;
        } else {
            mit3Punkten = 3;
        }
        //--------------Ueberschriften -------------------------
        // console.log(this.props);
        if (document.getElementsByClassName('printWandbeschreibung').length) {
            pdf.text(document.getElementsByClassName('printWandbeschreibung')[0].innerText, RandSeite, UnterBild + ZeilenabstandKlein * 0);
        }
        pdf.text(document.getElementsByClassName('Versorgungssysteme')[0].innerText, RandSeite, UnterBild + ZeilenabstandKlein * (6 - mit3Punkten));
        pdf.text(document.getElementsByClassName('Entwaesserungssysteme')[0].innerText, RandSeite, UnterBild + ZeilenabstandKlein * (10 - mit3Punkten));
        //pdf.setFont('AktivGroteskGeberit_W_Rg');

        //------- normale Texte ---------------------------------
        pdf.setFont(undefined, 'normal');
        if (this.props.steinsorte) {
            pdf.text(document.getElementsByClassName('steinsorteText')[0].innerText + ':', RandSeite, UnterBild + ZeilenabstandKlein * 1);
            pdf.text(document.getElementsByClassName('steinsorteVariable')[0].innerText, RandSeite + 50, UnterBild + ZeilenabstandKlein * 1);
        }

        //flaechengewicht
        if (this.props.korrekturWerte.flaechengewicht) {

          //  console.log(this.props);
            pdf.text(document.getElementsByClassName('printWanddicke')[0].innerText + ':', RandSeite, UnterBild + ZeilenabstandKlein * 2);
            pdf.text(this.props.wanddicke.replace('_', '.') + ' cm', RandSeite + 50, UnterBild + ZeilenabstandKlein * 2);

            pdf.text(document.getElementsByClassName('printPutz')[0].innerText, RandSeite, UnterBild + ZeilenabstandKlein * 3);
            if (this.props.putz) {
                pdf.text(this.props.messages.LabelJa, RandSeite + 50, UnterBild + ZeilenabstandKlein * 3);
                pdf.text(document.getElementsByClassName('printFlaechengewicht')[0].innerText, RandSeite, UnterBild + ZeilenabstandKlein * 4);
                pdf.text(String(this.props.korrekturWerte.flaechengewicht) + ' kg/m²', RandSeite + 50, UnterBild + ZeilenabstandKlein * 4);
            } else {
                pdf.text(this.props.messages.LabelNein, RandSeite + 50, UnterBild + ZeilenabstandKlein * 3);
                pdf.text(document.getElementsByClassName('printFlaechengewicht')[0].innerText, RandSeite, UnterBild + ZeilenabstandKlein * 4);
                pdf.text(String(this.props.korrekturWerte.flaechengewicht) + ' kg/m²', RandSeite + 50, UnterBild + ZeilenabstandKlein * 4);
            }
        }

        pdf.text(document.getElementsByClassName('Steigstrang')[0].innerText, RandSeite, UnterBild + ZeilenabstandKlein * (7 - mit3Punkten));
        pdf.text(document.getElementsByClassName('SteigstrangAktuell')[0].innerText, RandSeite + 50, UnterBild + ZeilenabstandKlein * (7 - mit3Punkten));
        pdf.text(document.getElementsByClassName('Anschlussleitungen')[0].innerText, RandSeite, UnterBild + ZeilenabstandKlein * (8 - mit3Punkten));
        pdf.text(
            document.getElementsByClassName('AnschlussleitungenVersorgung')[0].innerText,
            RandSeite + 50,
            UnterBild + ZeilenabstandKlein * (8 - mit3Punkten)
        );
        pdf.text(document.getElementsByClassName('Fallleitung')[0].innerText, RandSeite, UnterBild + ZeilenabstandKlein * (11 - mit3Punkten));
        pdf.text(document.getElementsByClassName('FallleitungAktuell')[0].innerText, RandSeite + 50, UnterBild + ZeilenabstandKlein * (11 - mit3Punkten));
        pdf.text(document.getElementsByClassName('Anschlussleitungen')[0].innerText, RandSeite, UnterBild + ZeilenabstandKlein * (12 - mit3Punkten));
        pdf.text(
            document.getElementsByClassName('AnschlussleitungenEntwaesserung')[0].innerText,
            RandSeite + 50,
            UnterBild + ZeilenabstandKlein * (12 - mit3Punkten)
        );
        //pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.text('2', 190, 289);

        //-------------------------- Seite 3 -------------------------------------------
        pdf.addPage();
        pdf.addImage(document.getElementsByClassName('GeberitPrintLogo')[0], 164.4, 8.4, 26, 3.5);
        pdf.setFont(undefined, 'bold');
        pdf.setFontSize(TextsizeMedium);

        //Tabelle
        // grauer hintergrund
        pdf.setLineWidth(0);
        pdf.setFillColor(236, 236, 236);
        pdf.rect(Spalte1, tabelleHeadlineUnten, Spalte2 - Spalte1, tabelleUnten - tabelleHeadlineUnten, 'F');
        pdf.rect(Trenner1, tabelleHeadlineUnten, spaltenBreiteRechts * 2, tabelleUnten - tabelleHeadlineUnten, 'F');
        //waagrechte Linien
        pdf.setLineWidth(0.2);
        pdf.setFillColor(0, 0, 0);
        pdf.line(RandSeite, tabelleOben, 190, tabelleOben);
        pdf.line(Spalte1, tabelleHeadlineUnten, Spalte4, tabelleHeadlineUnten);
        pdf.line(Trenner1, tabelleHeadlineUnten, 190, tabelleHeadlineUnten);
        pdf.line(RandSeite, tabelleZeile1, Spalte4, tabelleZeile1);
        pdf.line(Trenner1, tabelleZeile1, 190, tabelleZeile1);
        pdf.line(RandSeite, tabelleZeile2, Spalte4, tabelleZeile2);
        pdf.line(Trenner1, tabelleZeile2, 190, tabelleZeile2);
        pdf.line(RandSeite, tabelleUnten, 190, tabelleUnten);

        //senkrechte Linien
        pdf.line(RandSeite, tabelleOben, RandSeite, tabelleUnten);
        pdf.line(Spalte1, tabelleOben, Spalte1, tabelleUnten);
        pdf.line(Spalte2, tabelleHeadlineUnten, Spalte2, tabelleUnten);
        pdf.line(Spalte3, tabelleHeadlineUnten + ZeilenabstandKlein, Spalte3, tabelleUnten);
        pdf.line(Spalte4, tabelleOben, Spalte4, tabelleUnten);
        pdf.line(Trenner1, tabelleOben, Trenner1, tabelleUnten);
        pdf.line(Spalte5, tabelleHeadlineUnten + ZeilenabstandKlein * 2, Spalte5, tabelleUnten);
        pdf.line(Spalte6, tabelleHeadlineUnten, Spalte6, tabelleUnten);
        pdf.line(Spalte7, tabelleHeadlineUnten + ZeilenabstandKlein * 2, Spalte7, tabelleUnten - ZeilenabstandKlein);
        pdf.line(Spalte8, tabelleHeadlineUnten + ZeilenabstandKlein, Spalte8, tabelleUnten);
        pdf.line(Spalte9, tabelleHeadlineUnten + ZeilenabstandKlein * 2, Spalte9, tabelleZeile2 - ZeilenabstandKlein);
        pdf.line(Spalte9, tabelleZeile2, Spalte9, tabelleUnten - ZeilenabstandKlein);
        pdf.line(Spalte10, tabelleHeadlineUnten + ZeilenabstandKlein, Spalte10, tabelleUnten);
        pdf.line(Spalte11, tabelleHeadlineUnten + ZeilenabstandKlein * 2, Spalte11, tabelleZeile2 - ZeilenabstandKlein);
        pdf.line(Spalte11, tabelleUnten, Spalte11, tabelleZeile2);
        pdf.line(210 - RandSeite, tabelleOben, 210 - RandSeite, tabelleUnten);
        //pdf.setFont('AktivGroteskGeberit_W_Rg');
        pdf.setFont(undefined, 'normal');

        //Putz change everything
        var KorrekturFussnote = ['', ''];
        var FussnoteKorrektur = document.getElementsByClassName('PrintFussnoteKorrektur')[0].innerHTML;
        KorrekturFussnote = FussnoteKorrektur.replace('<span>', '');
        KorrekturFussnote = KorrekturFussnote.replace('</span>', '');
        KorrekturFussnote = KorrekturFussnote.split('<br>');
        var KorrekturAbstand = 4;
        var KorrekturAbstandUnten = 6;
        var CheckingPutz = document.getElementsByClassName('PutzCheck')[0].innerText;
        pdf.setFontSize(6);

        if (this.props.korrekturWerte.seitlich != 0) {
            KorrekturAbstand = 6;
            KorrekturAbstandUnten = 26;
            pdf.setFontSize(8);
            pdf.text(document.getElementsByClassName('SubheadlineTabelle')[0].innerText, RandSeite, tabelleOben - KorrekturAbstand + 3);
            pdf.setFontSize(8);
            for (var i = 0; i < KorrekturFussnote.length; i++) {
                pdf.text(KorrekturFussnote[i], RandSeite, tabelleUnten + 3.6 * 2 + 3.6 * i);
            }

            //pdf.setFont('AktivGroteskGeberit_W_Bd');
            pdf.setFontSize(6);
            pdf.setFont(undefined, 'bold');
            pdf.text(document.getElementsByClassName('PrintBerechnet')[0].innerText, Spalte1 + 1, tabelleHeadlineUnten + 3 + 2.8 * 4);
            pdf.text(document.getElementsByClassName('PrintBerechnet')[0].innerText, Trenner1 + 1, tabelleHeadlineUnten + 7.5);
        } else {
            KorrekturAbstand = 6;
            KorrekturAbstandUnten = 8;
        }
        pdf.setFontSize(9);
        //pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.setFont(undefined, 'bold');
        pdf.text(document.getElementsByClassName('PrintTableHeading')[0].innerText, RandSeite, tabelleOben - KorrekturAbstand);

        //tabelle Inhalt
        pdf.setFontSize(6);
        //pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.setFont(undefined, 'bold');
        pdf.text(document.getElementsByClassName('printMessort')[0].innerText, RandSeite + 1, tabelleOben + 3);
        pdf.text(document.getElementsByClassName('printAnforderung')[0].innerText, Spalte2 + 1, tabelleHeadlineUnten + 3);
        pdf.text(document.getElementsByClassName('printErgebnis')[0].innerText, Trenner1 + 1, tabelleHeadlineUnten + 3);
        pdf.text('VDI 4100:2012-10', Trenner1 + 1, tabelleHeadlineUnten + 5);
        pdf.text('VDI 4100 SSt I', Spalte6 + 1, tabelleHeadlineUnten + 6);
        pdf.text('VDI 4100 SSt II', Spalte8 + 1, tabelleHeadlineUnten + 6);
        pdf.text('VDI 4100 SSt III', Spalte10 + 1, tabelleHeadlineUnten + 6);
        pdf.setFont(undefined, 'bolditalic');
        pdf.setFont('Helvetica');
        pdf.text('L', Spalte2, tabelleOben + 4);
        pdf.text('L', Spalte8 - 6, tabelleOben + 4);
        pdf.setFont(undefined, 'normal');
        //pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.setFont(undefined, 'bold');
        pdf.text('AFmax,n', Spalte2 + 1.5, tabelleOben + 4.5);
        pdf.text('AFmax,nT', Spalte8 - 4.5, tabelleOben + 4.5);
        pdf.text(document.getElementsByClassName('printAnforderung')[0].innerText, Spalte8 + 1, tabelleHeadlineUnten + 3);
        pdf.line(Spalte8 - 5.5, tabelleOben + 2.3, Spalte8 + 5.5, tabelleOben + 2.3);
        //pdf.setFont('AktivGroteskGeberit_W_Rg');
        pdf.setFont(undefined, 'normal');
        pdf.setLineWidth(0.1);
        pdf.text('< 30 dB(A)', Spalte2 + 1, tabelleZeile1 + 7.1);
        pdf.line(Spalte2 + 1.1, tabelleZeile1 + 7.2, Spalte2 + 2, tabelleZeile1 + 7.2);
        pdf.text('< 25 dB(A)', Spalte3 + 1, tabelleZeile1 + 7.1);
        pdf.line(Spalte3 + 1.1, tabelleZeile1 + 7.2, Spalte3 + 2, tabelleZeile1 + 7.2);
        pdf.text('< 30 dB(A)', Spalte6 + 1, tabelleZeile1 + 7.1);
        pdf.line(Spalte6 + 1.1, tabelleZeile1 + 7.2, Spalte6 + 2, tabelleZeile1 + 7.2);
        pdf.text('< 27 dB(A)', Spalte8 + 1, tabelleZeile1 + 7.1);
        pdf.line(Spalte8 + 1.1, tabelleZeile1 + 7.2, Spalte8 + 2, tabelleZeile1 + 7.2);
        pdf.text('< 37 dB(A)', Spalte9 + 1, tabelleZeile1 + 7.1);
        pdf.line(Spalte9 + 1.1, tabelleZeile1 + 7.2, Spalte9 + 2, tabelleZeile1 + 7.2);
        pdf.text('< 24 dB(A)', Spalte10 + 1, tabelleZeile1 + 7.1);
        pdf.line(Spalte10 + 1.1, tabelleZeile1 + 7.2, Spalte10 + 2, tabelleZeile1 + 7.2);
        pdf.text('< 34 dB(A)', Spalte11 + 1, tabelleZeile1 + 7.1);
        pdf.line(Spalte11 + 1.1, tabelleZeile1 + 7.2, Spalte11 + 2, tabelleZeile1 + 7.2);
        pdf.text('< 35 dB(A)', Spalte6 + 1, tabelleZeile2 + 7.1);
        pdf.line(Spalte6 + 1.1, tabelleZeile2 + 7.2, Spalte6 + 2, tabelleZeile2 + 7.2);
        pdf.text('< 45 dB(A)', Spalte7 + 1, tabelleZeile2 + 7.1);
        pdf.line(Spalte7 + 1.1, tabelleZeile2 + 7.2, Spalte7 + 2, tabelleZeile2 + 7.2);
        pdf.text('< 30 dB(A)', Spalte8 + 1, tabelleZeile2 + 7.1);
        pdf.line(Spalte8 + 1.1, tabelleZeile2 + 7.2, Spalte8 + 2, tabelleZeile2 + 7.2);
        pdf.text('< 40 dB(A)', Spalte9 + 1, tabelleZeile2 + 7.1);
        pdf.line(Spalte9 + 1.1, tabelleZeile2 + 7.2, Spalte9 + 2, tabelleZeile2 + 7.2);
        //pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.setFont(undefined, 'bold');
        for (var i = 0; i < Diagonal1.length; i++) {
            pdf.text(Diagonal1[i], RandSeite + 1, tabelleZeile1 + 3 + 2.8 * i);
        }
        //pdf.setFont('AktivGroteskGeberit_W_Rg');
        pdf.setFont(undefined, 'normal');
        for (var i = 0; i < Fremden1.length; i++) {
            pdf.text(Fremden1[i], RandSeite + 1, tabelleZeile1 + 8.6 + 2.8 * i);
        }
        //pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.setFont(undefined, 'bold');
        for (var i = 0; i < Angrenzend1.length; i++) {
            pdf.text(Angrenzend1[i], RandSeite + 1, tabelleZeile2 + 3 + 2.8 * i);
        }
        for (var i = 0; i < Ergebnis1.length; i++) {
            pdf.text(Ergebnis1[i], Spalte1 + 1, tabelleHeadlineUnten + 3 + 2.8 * i);
        }
        for (var i = 0; i < DIN41094.length; i++) {
            pdf.text(DIN41094[i], Spalte1 + 1, tabelleHeadlineUnten + 3 + 2.8 * (i + 2));
        }
        for (var i = 0; i < DIN41091.length; i++) {
            pdf.text(DIN41091[i], Spalte2 + 1, tabelleHeadlineUnten + 3 + 2.8 * (i + 1));
        }
        for (var i = 0; i < DIN4109.length; i++) {
            pdf.text(DIN4109[i], Spalte3 + 1, tabelleHeadlineUnten + 3 + 2.8 * (i + 1));
        }
        //pdf.setFont('AktivGroteskGeberit_W_Rg');
        pdf.setFont(undefined, 'normal');
        pdf.text(document.getElementsByClassName('printBereichEigen')[0].innerText, RandSeite + 1, tabelleZeile2 + 3 + 2.8 * 2);
        for (var i = 0; i < KeineAnforderung1.length; i++) {
            pdf.text(KeineAnforderung1[i], Spalte2 + 1, tabelleZeile2 + 3 + 2.8 * i);
        }
        for (var i = 0; i < KeineAnforderung1.length; i++) {
            pdf.text(KeineAnforderung1[i], Spalte3 + 1, tabelleZeile2 + 3 + 2.8 * i);
        }
        for (var i = 0; i < KeineAnforderung1.length; i++) {
            pdf.text(KeineAnforderung1[i], Spalte10 + 1, tabelleZeile2 + 3 + 2.8 * i);
        }
        for (var i = 0; i < KeineAnforderung1.length; i++) {
            pdf.text(KeineAnforderung1[i], Spalte11 + 1, tabelleZeile2 + 3 + 2.8 * i);
        }
        for (var i = 0; i < KeineAnforderung1.length; i++) {
            pdf.text(KeineAnforderung1[i], Spalte7 + 1, tabelleZeile1 + 3 + 2.8 * i);
        }
        for (var i = 0; i < OhneBetaetigung1.length; i++) {
            pdf.text(OhneBetaetigung1[i], Trenner1 + 1, tabelleHeadlineUnten + 5 + 2.8 * (i + 2));
        }
        for (var i = 0; i < MitBetaetigung1.length; i++) {
            pdf.text(MitBetaetigung1[i], Spalte5 + 1, tabelleHeadlineUnten + 5 + 2.8 * (i + 2));
        }
        for (var i = 0; i < OhneBetaetigung1.length; i++) {
            pdf.text(OhneBetaetigung1[i], Spalte6 + 1, tabelleHeadlineUnten + 5 + 2.8 * (i + 2));
        }
        for (var i = 0; i < MitBetaetigung1.length; i++) {
            pdf.text(MitBetaetigung1[i], Spalte7 + 1, tabelleHeadlineUnten + 5 + 2.8 * (i + 2));
        }
        for (var i = 0; i < OhneBetaetigung1.length; i++) {
            pdf.text(OhneBetaetigung1[i], Spalte8 + 1, tabelleHeadlineUnten + 5 + 2.8 * (i + 2));
        }
        for (var i = 0; i < MitBetaetigung1.length; i++) {
            pdf.text(MitBetaetigung1[i], Spalte9 + 1, tabelleHeadlineUnten + 5 + 2.8 * (i + 2));
        }
        for (var i = 0; i < OhneBetaetigung1.length; i++) {
            pdf.text(OhneBetaetigung1[i], Spalte10 + 1, tabelleHeadlineUnten + 5 + 2.8 * (i + 2));
        }
        for (var i = 0; i < MitBetaetigung1.length; i++) {
            pdf.text(MitBetaetigung1[i], Spalte11 + 1, tabelleHeadlineUnten + 5 + 2.8 * (i + 2));
        }

        //Dynamic content
        //pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.setFont(undefined, 'bold');
        pdf.text(document.getElementsByClassName('ResultDiagonalDarunter')[0].innerText, Spalte1 + 1, tabelleZeile1 + 7.1);
        pdf.text(document.getElementsByClassName('ResultDiagonalDarunterOhne')[0].innerText, Trenner1 + 1, tabelleZeile1 + 7.1);
        pdf.text(document.getElementsByClassName('ResultDiagonalDarunterMit')[0].innerText, Spalte5 + 1, tabelleZeile1 + 7.1);
        pdf.text(document.getElementsByClassName('ResultAngrenzend')[0].innerText, Spalte1 + 1, tabelleZeile2 + 7.1);
        pdf.text(document.getElementsByClassName('ResultAngrenzendOhne')[0].innerText, Trenner1 + 1, tabelleZeile2 + 7.1);
        pdf.text(document.getElementsByClassName('ResultAngrenzendMit')[0].innerText, Spalte5 + 1, tabelleZeile2 + 7.1);
        //erfuellt nicht erfuellt
        pdf.text(document.getElementsByClassName('DIN41091Check')[0].innerText, Spalte2 + 1, tabelleZeile2 - 2);
        pdf.text(document.getElementsByClassName('DIN4109Beiblatt')[0].innerText, Spalte3 + 1, tabelleZeile2 - 2);
        pdf.text(document.getElementsByClassName('VDISST1Zeile1Check')[0].innerText, Spalte6 + 1, tabelleZeile2 - 2);
        pdf.text(document.getElementsByClassName('VDISST2Zeile1Check')[0].innerText, Spalte9 - 4, tabelleZeile2 - 2);
        pdf.text(document.getElementsByClassName('VDISST3Zeile1Check')[0].innerText, Spalte11 - 4, tabelleZeile2 - 2);
        pdf.text(document.getElementsByClassName('VDISST1Zeile2Check')[0].innerText, Spalte7 - 4, tabelleUnten - 2);
        pdf.text(document.getElementsByClassName('VDISST2Zeile2Check')[0].innerText, Spalte9 - 4, tabelleUnten - 2);
        //pdf.setFont('AktivGroteskGeberit_W_Rg');
        pdf.setFont(undefined, 'normal');

        //fussnote
        pdf.setFontSize(8);

        for (var i = 0; i < footNote1.length; i++) {
            pdf.text(footNote1[i], RandSeite, tabelleUnten + KorrekturAbstandUnten + 3.6 * i);
        }

        for (var i = 0; i < footNote2.length; i++) {
            pdf.text(footNote2[i], RandSeite, tabelleUnten + KorrekturAbstandUnten + (footNote1.length + 4 * 3.6) + 3.6 * i);
        }
        if (this.props.abwasserFallleitungActive == 'geberit_silent_pro' || this.props.abwasserFallleitungActive == 'geberit_silent_pro') {
            for (var i = 0; i < DruckSilentPro.length; i++) {
                pdf.text(DruckSilentPro[i], RandSeite, tabelleUnten + KorrekturAbstandUnten + (footNote1.length + footNote2.length + 2) * 3.6 + 3.6 * i);
            }
        }

        //link
        pdf.setFontSize(TextsizeMedium);
       // pdf.text(document.getElementsByClassName('LinkLine1')[0].innerText, RandSeite, 275);
       // pdf.text(document.getElementsByClassName('LinkLine2')[0].innerText, RandSeite, 280);
        pdf.setTextColor(58, 117, 196);
       // pdf.text('www.geberit.de/kb-schallschutz', 70, 280);
        pdf.setTextColor(0, 0, 0);

        pdf.text('3', 190, 289);

        if (this.props.korrekturWerte.seitlich != 0) {
            //-------------------------- Seite 4 -------------------------------------------
            pdf.addPage();
            pdf.addImage(document.getElementsByClassName('GeberitPrintSeite55')[0], 0, 16, 210, 265.2);
            pdf.addImage(document.getElementsByClassName('GeberitPrintLogo')[0], 164.4, 8.4, 26, 3.5);

            pdf.setTextColor(0, 0, 0);
            pdf.setFontSize(12);
            pdf.setFontSize(SeitenZahlen);
            pdf.text('4', 190, 289);
        }
        //AdtressSeite
        //-------------------------- Seite 4 , 5 -------------------------------------------
        pdf.addPage();

        pdf.setFontSize(TextsizeMedium);
        pdf.setTextColor(58, 117, 196);
        ////pdf.setFont('AktivGroteskGeberit_W_Bd');
        pdf.text(document.getElementsByClassName('AnschriftFirma')[0].innerText, RandSeite, ObersteZeile);
        //pdf.setFont('AktivGroteskGeberit_W_Rg');
        pdf.setFont(undefined, 'normal');
        pdf.text(document.getElementsByClassName('AnschriftStrasse')[0].innerText, RandSeite, ObersteZeile + ZeilenabstandMittel * 1);
        pdf.text(document.getElementsByClassName('AnschriftStadt')[0].innerText, RandSeite, ObersteZeile + ZeilenabstandMittel * 2);

        pdf.text(document.getElementsByClassName('AnschriftTelefonUeberschrift')[0].innerText, RandSeite, ObersteZeile + ZeilenabstandMittel * 4);
        pdf.text(document.getElementsByClassName('AnschriftTelefon')[0].innerText, RandSeite, ObersteZeile + ZeilenabstandMittel * 5);
        pdf.text(document.getElementsByClassName('AnschriftFax')[0].innerText, RandSeite, ObersteZeile + ZeilenabstandMittel * 6);
        pdf.text(document.getElementsByClassName('AnschriftEmail')[0].innerText, RandSeite, ObersteZeile + ZeilenabstandMittel * 7);
        pdf.text(document.getElementsByClassName('AnschriftUrl')[0].innerText, RandSeite, ObersteZeile + ZeilenabstandMittel * 9);

        pdf.addImage(document.getElementsByClassName('GeberitPrintLogo')[0], 164.4, 8.4, 26, 3.5);
        pdf.setTextColor(0, 0, 0);
        pdf.setFontSize(12);
        pdf.setFontSize(SeitenZahlen);
        if (this.props.korrekturWerte.seitlich != 0) {
            pdf.text('5', 190, 289);
        } else {
            pdf.text('4', 190, 289);
        }
        document.getElementById("iconButton").src = Save;
        pdf.save('GeberitiHeliisolatsiooniTööriist.pdf');

    };

    viewPortSmall = () => {
        this.setState({
            viewPortSmall: window.innerWidth < 500,
        });
    };

    render() {

        const { putz, result, korrekturWerte, abwasserFallleitungActive, abwasserAnschlussleitungActive } = this.props;
        const viewPortSmall = this.state.viewPortSmall;

        const getScaleValues = () => {
            return {
                LAF_DIN_angrenzenderRaumMinScale: Math.min.apply(null, DATA.map(result => result.LAF_DIN_angrenzenderRaum)),
                LAF_DIN_angrenzenderRaumMaxScale: Math.max.apply(null, DATA.map(result => result.LAF_DIN_angrenzenderRaum)),
                LAF_DIN_diagonalDarunterliegenderRaumMinScale: Math.min.apply(null, DATA.map(result => result.LAF_DIN_diagonalDarunterliegenderRaum)),
                LAF_DIN_diagonalDarunterliegenderRaumMaxScale: Math.max.apply(null, DATA.map(result => result.LAF_DIN_diagonalDarunterliegenderRaum)),
                LAF_VDI_mitGeraeuschenImAngrenzendenRaumMinScale: Math.min.apply(null, DATA.map(result => result.LAF_VDI_mitGeraeuschenImAngrenzendenRaum)),
                LAF_VDI_mitGeraeuschenImAngrenzendenRaumMaxScale: Math.max.apply(null, DATA.map(result => result.LAF_VDI_mitGeraeuschenImAngrenzendenRaum)),
                LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaumMinScale: Math.min.apply(
                    null,
                    DATA.map(result => result.LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum)
                ),
                LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaumMaxScale: Math.max.apply(
                    null,
                    DATA.map(result => result.LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum)
                ),
            };
        };

        const scaleValues = getScaleValues();

        return (
            <ErgebnisseWrapper>
                <ErgebnisseComponents>
                    <ErgebnisseHeading>
                        {result.installationsGeraeuscheTableHeading === <FormattedHTMLMessage id="KeineMessdaten" /> ? (
                            <Warning>{result.installationsGeraeuscheTableHeading}</Warning>
                        ) : (
                                <>{result.installationsGeraeuscheTableHeading}</>
                            )}
                        <ErgebnisseSubheading>
                            {korrekturWerte.seitlich != 0 && (
                                <>
                                    <FloatLeft>
                                        <FormattedHTMLMessage id="ergebniss-subheadline-korrektur" />
                                    </FloatLeft>
                                    <FloatLeft>
                                        <InfoBox content={<KorrekturSchallpegel />} />{' '}
                                    </FloatLeft>
                                </>
                            )}
                        </ErgebnisseSubheading>
                    </ErgebnisseHeading>

                    <ErgebnisseRowFirst>
                        <ErgebnisseRowHeading>
                            <FormattedHTMLMessage id="ErgebnisseErsteReihe" />
                        </ErgebnisseRowHeading>
                        <Schallberechnung
                            heading={<FormattedHTMLMessage id="DiagonalDarunter" />}
                            scaleMinValue={scaleValues.LAF_DIN_diagonalDarunterliegenderRaumMinScale}
                            scaleMaxValue={scaleValues.LAF_DIN_diagonalDarunterliegenderRaumMaxScale}
                            limitFirstLine={30}
                            value={result.LAF_DIN_diagonalDarunterliegenderRaumMitKorrekturWerten}
                            firstLineToolTip=" dB(A)"
                            icon={SoundArrowDiagonal}
                        />
                        <Schallberechnung
                            heading={<FormattedHTMLMessage id="AngrenzenderRaum" />}
                            scaleMinValue={scaleValues.LAF_DIN_angrenzenderRaumMinScale}
                            scaleMaxValue={scaleValues.LAF_DIN_angrenzenderRaumMaxScale}
                            value={result.LAF_DIN_angrenzenderRaumMitKorrekturWerten}
                            firstLineToolTip=" dB(A)"
                            icon={SoundArrowHorizontal}
                            hasInfoBox={true}
                            infoBoxHeadline={<FormattedHTMLMessage id="Header_Geraeusche" />}
                            infoBoxPositioning={'right'}
                            infoBoxContent={<Geraeusche />}
                        />
                    </ErgebnisseRowFirst>
                    <ErgebnisseRowSecond>
                        <ErgebnisseRowHeading>
                            <FormattedHTMLMessage id="ErgebnisseZweiteReihe" />
                        </ErgebnisseRowHeading>
                        <Schallberechnung
                            heading={<FormattedHTMLMessage id="DiagonalDarunter" />}
                            scaleMinValue={scaleValues.LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaumMinScale}
                            scaleMaxValue={scaleValues.LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaumMaxScale}
                            limitFirstLine={30}
                            limitSecondLine={40}
                            value={result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten}
                            firstLineToolTip={<FormattedHTMLMessage id="OhneBetaetigungsgeraeusche" />}
                            secondLineValue={result.LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaumMitKorrekturWerten}
                            secondLineToolTip={<FormattedHTMLMessage id="Betaetigungsgeraeusche" />}
                            icon={SoundArrowDiagonal}
                            secondLine={true}
                        />
                        <Schallberechnung
                            heading={<FormattedHTMLMessage id="AngrenzenderRaum" />}
                            scaleMinValue={scaleValues.LAF_VDI_mitGeraeuschenImAngrenzendenRaumMinScale}
                            scaleMaxValue={scaleValues.LAF_VDI_mitGeraeuschenImAngrenzendenRaumMaxScale}
                            limitFirstLine={35}
                            limitSecondLine={45}
                            value={result.LAF_VDI_ohneGeraeuscheImAngrenzendenRaumMitKorrekturWerten}
                            firstLineToolTip={<FormattedHTMLMessage id="OhneBetaetigungsgeraeusche" />}
                            secondLineValue={result.LAF_VDI_mitGeraeuschenImAngrenzendenRaumMitKorrekturWerten}
                            secondLineToolTip={<FormattedHTMLMessage id="Betaetigungsgeraeusche" />}
                            icon={SoundArrowHorizontal}
                            secondLine={true}
                        />
                    </ErgebnisseRowSecond>
                    <ErgebnisseTable>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <Hausart>
                                        <FormattedHTMLMessage id="hausart-label" className="beispiel" />
                                    </Hausart>
                                    <Normen colSpan={3}>
                                        <FloatLeft>

                                            <FormattedHTMLMessage id="normen-und-richtlinien-label" />
                                        </FloatLeft>
                                        <FloatLeftHeaderTable>
                                            <InfoBox content={<Normeninfo />} headline={''} />{' '}
                                        </FloatLeftHeaderTable>
                                    </Normen>
                                </tr>
                                <TableRowStrongBottomBorder>
                                    <TDDescription>
                                        {viewPortSmall ? (
                                            <>
                                                <FloatLeft>
                                                    <FormattedHTMLMessage id="mehrfamilienhaus-short" />
                                                </FloatLeft>
                                                <FloatRight>
                                                    <InfoBox content={<MehrfamilienhausDIN />} headline={<FormattedHTMLMessage id="Mehrfamilienhaus_DIN_Headline" />} />{' '}
                                                </FloatRight>
                                            </>
                                        ) : (
                                                <>
                                                    <FloatLeft>
                                                        <FormattedHTMLMessage id="mehrfamilienhaus-long" />
                                                    </FloatLeft>
                                                    <FloatRight>
                                                        <InfoBox content={<MehrfamilienhausDIN />} headline={<FormattedHTMLMessage id="Mehrfamilienhaus_DIN_Headline" />} />{' '}
                                                    </FloatRight>
                                                </>
                                            )}
                                    </TDDescription>

                                    <td>
                                        DIN 4109-1:2018-1
                                        {result.LAF_DIN_diagonalDarunterliegenderRaumMitKorrekturWerten <= 30 ? (
                                            <CheckedIcon src={Checked} />
                                        ) : (
                                                <CrossIcon src={Cross} />
                                            )}
                                    </td>
                                    <td>
                                        DIN 4109 Supplement 2:1989-11
                                        {result.LAF_DIN_diagonalDarunterliegenderRaumMitKorrekturWerten <= 25 ? (
                                            <CheckedIcon src={Checked} />
                                        ) : (
                                                <CrossIcon src={Cross} />
                                            )}
                                    </td>
                                    <td />
                                </TableRowStrongBottomBorder>
                                <tr>
                                    <TDDescription>
                                        {viewPortSmall ? (
                                            <>
                                                <FloatLeft>
                                                    <FormattedHTMLMessage id="mehrfamilienhaus-short" />
                                                </FloatLeft>
                                                <FloatRight>
                                                    <InfoBox content={<MehrfamilienhausVDI />} headline={<FormattedHTMLMessage id="Mehrfamilienhaus_VDI_Headline" />} />
                                                </FloatRight>
                                            </>
                                        ) : (
                                                <>
                                                    <FloatLeft>
                                                        <FormattedHTMLMessage id="mehrfamilienhaus-long" />
                                                    </FloatLeft>
                                                    <FloatRight>
                                                        <InfoBox content={<MehrfamilienhausVDI />} headline={<FormattedHTMLMessage id="Mehrfamilienhaus_VDI_Headline" />} />
                                                    </FloatRight>
                                                </>
                                            )}
                                    </TDDescription>
                                    <td>
                                        VDI 4100:2012-10 SST I
                                        {result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= 30 ? (
                                            <CheckedIcon src={Checked} />
                                        ) : (
                                                <CrossIcon src={Cross} />
                                            )}
                                    </td>
                                    <td>
                                        VDI 4100:2012-10 SST II
                                        {result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= 27 ? (
                                            <CheckedIcon src={Checked} />
                                        ) : (
                                                <CrossIcon src={Cross} />
                                            )}
                                    </td>
                                    <td>
                                        VDI 4100:2012-10 SST III
                                        {result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= 24 ? (
                                            <CheckedIcon src={Checked} />
                                        ) : (
                                                <CrossIcon src={Cross} />
                                            )}
                                    </td>
                                </tr>
                                <tr>
                                    <TDDescription>
                                        {viewPortSmall ? (
                                            <>
                                                <FloatLeft>
                                                    <FormattedHTMLMessage id="einfamilienhaus-short" />
                                                </FloatLeft>
                                                <FloatRight>
                                                    <InfoBox content={<Einfamilienhaus />} headline={<FormattedHTMLMessage id="Einfamilienhaus_Headline" />} />
                                                </FloatRight>
                                            </>
                                        ) : (
                                                <>
                                                    <FloatLeft>
                                                        <FormattedHTMLMessage id="einfamilienhaus-long" />
                                                    </FloatLeft>
                                                    <FloatRight>
                                                        <InfoBox content={<Einfamilienhaus />} headline={<FormattedHTMLMessage id="Einfamilienhaus_Headline" />} />
                                                    </FloatRight>
                                                </>
                                            )}
                                    </TDDescription>
                                    <td>
                                        VDI 4100:2012-10 SST I
                                        {result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= 30 ? (
                                            <CheckedIcon src={Checked} />
                                        ) : (
                                                <CrossIcon src={Cross} />
                                            )}
                                    </td>
                                    <td>
                                        VDI 4100:2012-10 SST II
                                        {result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= 25 ? (
                                            <CheckedIcon src={Checked} />
                                        ) : (
                                                <CrossIcon src={Cross} />
                                            )}
                                    </td>
                                    <td>
                                        VDI 4100:2012-10 SST III
                                        {result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= 22 ? (
                                            <CheckedIcon src={Checked} />
                                        ) : (
                                                <CrossIcon src={Cross} />
                                            )}
                                    </td>
                                </tr>
                                <tr>
                                    <TDDescription>
                                        {viewPortSmall ? (
                                            <>
                                                <FloatLeft>
                                                    <FormattedHTMLMessage id="im-eigenen-bereich-short" />
                                                </FloatLeft>
                                                <FloatRight>
                                                    <InfoBox content={<Imeigenenbereich />} headline={<FormattedHTMLMessage id="ImEigenenBereich_Headline" />} />
                                                </FloatRight>
                                            </>
                                        ) : (
                                                <>
                                                    <FloatLeft>
                                                        <FormattedHTMLMessage id="im-eigenen-bereich-long" />
                                                    </FloatLeft>
                                                    <FloatRight>
                                                        <InfoBox content={<Imeigenenbereich />} headline={<FormattedHTMLMessage id="ImEigenenBereich_Headline" />} />
                                                    </FloatRight>
                                                </>
                                            )}
                                    </TDDescription>

                                    <td>
                                        VDI 4100:2012-10 SSt EB I
                                        {result.LAF_VDI_ohneGeraeuscheImAngrenzendenRaumMitKorrekturWerten <= 35 ? (
                                            <CheckedIcon src={Checked} />
                                        ) : (
                                                <CrossIcon src={Cross} />
                                            )}
                                    </td>
                                    <td>
                                        VDI 4100:2012-10 SSt EB II
                                        {result.LAF_VDI_ohneGeraeuscheImAngrenzendenRaumMitKorrekturWerten <= 30 ? (
                                            <CheckedIcon src={Checked} />
                                        ) : (
                                                <CrossIcon src={Cross} />
                                            )}
                                    </td>
                                    <td />
                                </tr>
                            </tbody>
                        </StyledTable>
                    </ErgebnisseTable>
                    <Footer>
                        <FooterTextRow>
                            <FooterLogo>
                                <img src={Logo} alt="Logo" />
                            </FooterLogo>
                            <FooterText>
                                <FormattedHTMLMessage id="fussnote-allgemein" />
                                <br />
                                <br />

                                {(abwasserFallleitungActive === 'geberit_silent_pro' || abwasserAnschlussleitungActive === 'geberit_silent_pro') && (
                                    <FormattedHTMLMessage id="fussnote-silent-pro" />
                                )}
                            </FooterText>
                        </FooterTextRow>
                        <FooterButtonsRow>
                            <form onSubmit={this.handleSubmit}>
                                <FormularDiv>
                                    <LabelPrint className="titlePrint"><FormattedHTMLMessage id="Pdf_Anfrage_Titel" /></LabelPrint>
                                </FormularDiv>
                                <FormularDiv>
                                    <InputFieldPrint
                                        placeholder="max. 22 characters"
                                        type="text"
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        required
                                        maxLength="22"
                                    />
                                </FormularDiv>
                                <FormularDiv>
                                    <LabelPrint className="creatorPrint"><FormattedHTMLMessage id="Pdf_Anfrage_Absender" /></LabelPrint>
                                </FormularDiv>
                                <FormularDiv>
                                    <InputFieldPrint placeholder="max. 40 characters " type="text" value2={this.state.value2} onChange={this.handleChange2} maxLength="40" />
                                </FormularDiv>
                                <FormularDiv>
                                    <LabelPrint className="descriptionPrint"><FormattedHTMLMessage id="Pdf_Anfrage_Beschreibung" /></LabelPrint>
                                </FormularDiv>
                                <FormularDiv>
                                    <TextAreaPrint placeholder="max. 140 characters " value3={this.state.value3} onChange={this.handleChange3} maxLength="140" />
                                </FormularDiv>
                                <FormularDiv />
                                <FooterButtonGrp>
                                    <DownloadBtn type="submit" id="downloadButton" value="Submit" onClick={this.changeIcon}>
                                        <img id="iconButton" src={Save} />
                                        <FormattedHTMLMessage id="download-btn" />
                                    </DownloadBtn>
                                    <div style={{ display: 'none' }}>
                                        <PrintVariables
                                            abwasserAn={abwasserAnschlussleitungActive}
                                            abwasserFa={abwasserFallleitungActive}
                                            allProps={this.props}
                                            inhalt="try this"
                                            image={SoundArrowHorizontal}
                                        />
                                    </div>
                                </FooterButtonGrp>
                            </form>
                        </FooterButtonsRow>
                    </Footer>
                </ErgebnisseComponents>
            </ErgebnisseWrapper>
        );
    }
}
const mapStateToProps = state => ({
    putz: state.choices.putz,
    steinsorte: state.choices.steinsorte,
    wanddicke: state.choices.wandstaerke,
    messages: state.intl.messages,
});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Ergebnisse);

const ErgebnisseRowHeading = styled.h3`
    padding: 10px;
`;
const InputFieldPrint = styled.input`
    background: #fff;
    font-size: 15px;
    color: #586069;
    width: 100%;
    padding: 10px 5px;
    box-sizing: border-box;
    border: 1px solid #84909d;
    border-radius: 0;
    height: 41px;
    margin-bottom: 20px;
`;
const TextAreaPrint = styled.textarea`
    background: #fff;
    font-size: 15px;
    color: #586069;
    width: 100%;
    padding: 10px 5px;
    box-sizing: border-box;
    border: 1px solid #84909d;
    border-radius: 0;
    resize: none;
    height: 80px;
    margin-bottom: 20px;
    font-family: inherit;
`;
const LabelPrint = styled.label`
    color: #84909d;
    font-weight: 700;
    font-size: 15px;
    line-height: 1.428571429;
`;

const Footer = styled.div`
    min-height: 317px;
`;
const ErgebnisseSubheading = styled.div`
    font-size: 15px;
    color: black;
    font-family: GROTESK Regular !important;
   
`;
const FooterTextRow = styled.div`
    padding: 5rem 3rem;
    display: flex;
    align-items: center;
    justify-content: space-around;

    ${borders.borderRight} ${colors.borderColor};
    ${borders.borderLeft} ${colors.borderColor};
`;
const TableRowStrongBottomBorder = styled.tr`
    border-bottom: solid 0.3rem #cccccc !important;
`;

const FooterButtonsRow = styled.div`
    padding: 2rem 3rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    ${borders.borderBottom} ${colors.borderColor};
    ${borders.borderLeft} ${colors.borderColor};
    ${borders.borderRight} ${colors.borderColor};
    background-color: ${colors.resultColorLineBg};
    ${mediaQ.tablet`
       justify-content: center;
    `}
`;

const ErgebnisseHeading = styled.h2`
    width: 100%;
    font-weight: bold;
    margin-bottom: 2rem;
    display: block;
`;

const ErgebnisseComponents = styled.div`
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    ${mediaQ.tablet`        
        width: 100%;
    `}
`;

const ErgebnisseWrapper = styled.div`
    padding-right: 50px;
    padding-left: 50px;
    margin-right: auto;
    margin-left: auto;
    max-width: 1400px;
    display: flex;
    flex-direction: column;
  
    margin-bottom: 10px;
    ${mediaQ.tablet`
        padding-right: 15px;
        padding-left: 15px;
        margin-bottom: 0;
    `}
`;

const FooterLogo = styled.div`
    ${mediaQ.tablet`
        display: none;
    `}
    img {
        height: auto;
        width: 100%;
        object-fit: cover;
    }
`;

const FormularDiv = styled.div`
    width: 100%;
    float: right;
`;

const FooterText = styled.div`
    flex: 0 0 70%;
    max-width: 70%;
    line-height: 1.5rem;
    font-size: 0.9rem;
`;

const FooterButtonGrp = styled.div`
    margin-right: 38px;
    ${mediaQ.tablet`
        margin-right: 0;
        align-items: center;

    `}
`;

const DownloadBtn = styled(ButtonPrimary)`
    img {
        vertical-align: text-bottom;
        padding-right: 17px;
    }
    ${mediaQ.tablet`
        margin-left: 0;
        margin-top: 15px;
    `}
`;

const ResetBtn = styled(ButtonDisabled)`
    margin-left: 16.8px;
    height: 38px;
    width: 186px;
`;

const ErgebnisseTable = styled.div`
    min-height: 201px;
    line-height:20px;
`;

const TDDescription = styled.td`
    padding-left: 0px;
    font-size: 15px;
    font-family:GROTESK Bold;
    line-height:20px;
    display: flex;
    align-items: first baseline;
    justify-content: space-between;
    align-content: space-between;
    border: none !important;
    width: 100% !important;#

    ${mediaQ.phone`
        padding-left: 10px !important;
    `};
`;

const Hausart = styled.th`   

`;

const Normen = styled.th`   

`;

const CheckedIcon = styled.img`
    float: right;
    max-width: 17px;
`;

const CrossIcon = styled.img`
    float: right;
    max-width: 17px;
`;

const StyledTable = styled.table`
    width: 100%;
    height: 100%;
    ${mediaQ.phone`
        table-layout: fixed;
    `}
    td, tr {
        vertical-align: middle;
    }
    td, th {
        width: 25%;
        font-size: 15px;
        padding: 15px 30px;
    }
    td {        

        ${borders.borderLeft} ${colors.borderColor};
        ${borders.borderRight} ${colors.borderColor};        
    }
    tr {        
        ${borders.borderBottom} ${colors.borderColor};
        ${borders.borderLeft} ${colors.borderColor};
    }
    th {
        text-align: left;
        font-family: GROTESK Bold;
        ${borders.borderRight} ${colors.borderColor};
        ${mediaQ.tablet`
        text-align: center;
        `};
    }
`;
const FloatRight = styled.div`
    float: right;
`;
const FloatLeft = styled.div`
    float: left;
`;
const FloatLeftHeaderTable = styled.div`
    float: left;
    position:absolute;
    margin-left:165px;
    margin-top: -3px;
`;

const ErgebnisseRow = styled.div`
    padding: 20px;
    min-height: 167.5px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    ${mediaQ.phone`
        flex-direction: column;
        padding: 10px;
    `}
`;

const ErgebnisseRowFirst = styled(ErgebnisseRow)`
    ${borders.border} ${colors.borderColor};
    ${mediaQ.phone`
        flex-direction: column;
    `}
`;

const ErgebnisseRowSecond = styled(ErgebnisseRow)`
    ${borders.borderBottom} ${colors.borderColor};
    ${borders.borderLeft} ${colors.borderColor};
    ${borders.borderRight} ${colors.borderColor};
`;

const Warning = styled.div`
    background: #ffbbbb;
    border: 1px solid red;
    padding: 14px;
    font-size: 15px;
`;
